import { createContext } from 'react';
import { ApplicationMenu } from '../../utils/applicationMenu/applicationMenu.js';

var ApplicationMenuContext = /*#__PURE__*/createContext(new ApplicationMenu());

export { ApplicationMenuContext };
